export interface TestimonialItem {
  id: string;
  name: string;
  university: string;
  rating: number;
  content: string;
  service: string;
  date: string;
}

export const testimonials: TestimonialItem[] = [
  {
    id: 't1',
    name: '小雨',
    university: '北京大学',
    rating: 5,
    content: '第一次来就被圈粉了！剪的发型超级好看，室友都说像换了一个人。价格对学生来说真的很友好，已经推荐给全班女生了~',
    service: '日系空气感剪发',
    date: '2026-08-08',
  },
  {
    id: 't2',
    name: '思涵',
    university: '复旦大学',
    rating: 5,
    content: '毕业照妆容在这里做的，效果太惊艳了！摄影师一直夸我上镜，底妆从早上九点扛到下午四点都没脱，太牛了。',
    service: '毕业照专属妆',
    date: '2026-07-22',
  },
  {
    id: 't3',
    name: '嘉怡',
    university: '浙江大学',
    rating: 5,
    content: '每个月都会来做一次基础清洁补水，皮肤真的稳定了很多。以前换季就过敏，现在已经半年没出过问题了。比买一堆贵妇护肤品有用太多！',
    service: '基础清洁补水',
    date: '2026-08-01',
  },
  {
    id: 't4',
    name: '若琳',
    university: '武汉大学',
    rating: 5,
    content: '和闺蜜一起来做的闺蜜套餐，两个人一起变美的感觉太快乐了！发型师很耐心，会认真听你的想法，不会强行推销。',
    service: '闺蜜双人套餐',
    date: '2026-07-28',
  },
  {
    id: 't5',
    name: '梓涵',
    university: '南京大学',
    rating: 4,
    content: '韩式渐变美甲做了一个月了，一点没掉！颜色还是很亮，闺蜜天天问我哪做的。下次想试试彩绘款~',
    service: '韩系渐变美甲',
    date: '2026-08-03',
  },
  {
    id: 't6',
    name: '一诺',
    university: '中山大学',
    rating: 5,
    content: '军训晒黑了好多，听了学姐推荐来这里做了亮白修复，3次之后室友都说我白回来了！而且用的产品很温和，敏感肌也没有不适。',
    service: '亮白淡印修复',
    date: '2026-07-18',
  },
];

export const stats = [
  { value: 5000, suffix: '+', label: '服务过的女大学生' },
  { value: 98, suffix: '%', label: '客户满意度' },
  { value: 50, suffix: '+', label: '合作高校' },
  { value: 3, suffix: '年', label: '专注校园美容' },
];